export default __webpack_public_path__ + "static/media/SecondaryLogoWhite.c490492f.png";